import type { FC, SVGAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

import { Tooltip } from '../GraphModal/Tooltip';

type RoundIconButtonProps = {
  title?: string;
  icon: FC<SVGAttributes<SVGElement>>;
  className?: string;
  iconClassName?: string;
  iconContainerClassName?: string;
  onClick?: (...args: any[]) => void;
  tooltip?: string;
};

export const RoundIconButton = (props: RoundIconButtonProps) => {
  const { tooltip, ...basicProps } = props;
  return tooltip ? (
    <WithTooltipRoundIconButton {...props} />
  ) : (
    <BasicRoundIconButton {...basicProps} />
  );
};

const BasicRoundIconButton = ({
  title,
  icon,
  onClick,
  className,
  iconContainerClassName,
  iconClassName,
}: Omit<RoundIconButtonProps, 'tooltip'>) => {
  const IconComponent = icon;

  return (
    <button
      title={title}
      type="button"
      className={twMerge(
        'relative h-10 w-10 bg-white rounded-full border border-gray-200 group hover:bg-primary transition-all',
        className,
      )}
      onClick={onClick}
    >
      <div
        className={twMerge(
          'absolute top-0 h-full w-full flex items-center justify-center',
          iconContainerClassName,
        )}
      >
        <IconComponent
          className={twMerge('h-5 w-5 group-hover:fill-white fill-gray-500', iconClassName)}
        />
      </div>
    </button>
  );
};

const WithTooltipRoundIconButton = ({ tooltip, ...basicProps }: RoundIconButtonProps) => {
  return (
    <Tooltip content={tooltip}>
      <BasicRoundIconButton {...basicProps} />
    </Tooltip>
  );
};
